import { provinceAndCityData, codeToText } from 'element-china-area-data'

/**
 * 将进件城市转为"省 / 市"两级展示，如 "长春市" -> "吉林省 / 长春市"
 * 兼容市级名称（如"长春市"）、省级名称（如"吉林省"）、行政区代码（如"220100"）
 * 无法匹配时原样返回
 */
export function getCityFullName(value) {
  if (!value) return value || ''
  const name = String(value).trim()
  if (!name) return value
  // 若是行政区代码，先转为名称
  const text = codeToText[name] || name
  for (const province of provinceAndCityData) {
    if (province.label === text) {
      return province.label
    }
    if (province.children) {
      for (const city of province.children) {
        if (city.label === text) {
          return province.label + ' / ' + city.label
        }
      }
    }
  }
  return value
}
